var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import Vue from 'vue';
import Vuex, { Store } from 'vuex';
import EventEmitter from 'events';
const wait = __GMK_VUEX_WAIT_TO_MOUNT__ || false;
const donebus = new EventEmitter();
class GMKVueSequencingWrapper extends Vue {
    $mount(...params) {
        var _a;
        //validations
        if (this.__$gmkVuexDone) {
            return this.__$gmkVuexMountOverride.apply(this, params);
        }
        if (!wait) {
            return this.__$gmkVuexMountOverride.apply(this, params);
        }
        if (!this.$store) {
            return this.__$gmkVuexMountOverride.apply(this, params);
        }
        if (!(this.$store instanceof GMKVuexSequencingWrapper)) {
            console.warn(`[@growmark/vuex](${__GMK_VUEX_APP_NAME__}): vuex store not correct instance type, be sure to create vuex using "new Vuex.Store({ ... })" and not "new Store({ ... })"`);
            return this.__$gmkVuexMountOverride.apply(this, params);
        }
        if (this.$store._$gmkSequencedProcessed) {
            return this.__$gmkVuexMountOverride.apply(this, params);
        }
        //set us up for processing
        __GMK_VUEX_DEBUG__ && console.debug(`[@growmark/vuex](${__GMK_VUEX_APP_NAME__}): delaying mount invoke till done sequencing`, (_a = this === null || this === void 0 ? void 0 : this.$options) === null || _a === void 0 ? void 0 : _a.name);
        donebus.once('state.ready', () => {
            var _a;
            __GMK_VUEX_DEBUG__ && console.debug(`[@growmark/vuex](${__GMK_VUEX_APP_NAME__}): mounting...`, (_a = this === null || this === void 0 ? void 0 : this.$options) === null || _a === void 0 ? void 0 : _a.name);
            this.__$gmkVuexDone = true;
            this.__$gmkVuexMountOverride.apply(this, params); //actually do the mount
        });
        if (this.$store._$gmkSequencedProcessing) {
            return this;
        }
        //do setup
        const store = this.$store;
        if (!store._$gmkSequencedPlugins) {
            console.debug(`[@growmark/vuex](${__GMK_VUEX_APP_NAME__}): no plugins to process`);
            return this.__$gmkVuexMountOverride.apply(this, params);
        }
        store._$gmkSequencedProcessing = true;
        //actual do the sequencing here
        const plugins = store._$gmkSequencedPlugins;
        (async () => {
            __GMK_VUEX_DEBUG__ && console.debug(`[@growmark/vuex](${__GMK_VUEX_APP_NAME__}): starting plugin sequencing`);
            for (const plugin of plugins) {
                try {
                    await (plugin === null || plugin === void 0 ? void 0 : plugin(this.$store));
                }
                catch (error) {
                    console.error(`[@growmark/vuex](${__GMK_VUEX_APP_NAME__}):`, error);
                }
            }
            __GMK_VUEX_DEBUG__ && console.debug(`[@growmark/vuex](${__GMK_VUEX_APP_NAME__}): finished plugin sequencing`);
            store._$gmkSequencedProcessed = true; //indicate completion for subsequent mounts
            donebus.emit('state.ready');
        })();
        return this;
    }
}
class GMKVuexSequencingWrapper extends Store {
    constructor(options) {
        const { plugins: original } = options, others = __rest(options, ["plugins"]);
        //create instance by passing to parent
        super(others);
        //store plugins for possible processing later
        this._$gmkSequencedPlugins = (original || []);
        if (wait) {
            return this;
        }
        if (this._$gmkSequencedProcessed) {
            return this;
        }
        this._$gmkSequencedProcessed = true;
        //actual do the sequencing here
        (async () => {
            this._$gmkSequencedProcessing = true;
            __GMK_VUEX_DEBUG__ && console.debug(`[@growmark/vuex](${__GMK_VUEX_APP_NAME__}): starting plugin sequencing`);
            for (const plugin of this._$gmkSequencedPlugins) {
                try {
                    await (plugin === null || plugin === void 0 ? void 0 : plugin(this));
                }
                catch (error) {
                    console.error(`[@growmark/vuex](${__GMK_VUEX_APP_NAME__}):`, error);
                }
            }
            __GMK_VUEX_DEBUG__ && console.debug(`[@growmark/vuex](${__GMK_VUEX_APP_NAME__}): finished plugin sequencing`);
        })();
    }
    ;
}
const V = Vue;
if (!V.prototype.__$gmkVuexMountOverride) {
    V.prototype.__$gmkVuexBus = new EventEmitter();
    V.prototype.__$gmkVuexDone = false;
    V.prototype.__$gmkVuexMountOverride = V.prototype.$mount;
    try {
        V.prototype.$mount = GMKVueSequencingWrapper.prototype.$mount;
    }
    catch (error) {
        console.warn(`[@growmark/vuex](${__GMK_VUEX_APP_NAME__}): an unexpected issue occurred overwriting vue to override '.$mount(...)'`, error);
    }
}
if (!(Vuex.Store instanceof GMKVuexSequencingWrapper)) {
    try {
        Vuex.Store = GMKVuexSequencingWrapper;
    }
    catch (error) {
        console.warn(`[@growmark/vuex](${__GMK_VUEX_APP_NAME__}): an unexpected issue occurred overwriting vuex to override constructor`, error);
    }
}
//# sourceMappingURL=index.js.map